import {
  WSElementProps,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useCreateContractorModal } from "../../components/CreateContractorModal/useCreateContractorModal";
import { PAYEES_ROOT_PATH } from "../../utils";
import { useOpenModalBySearchParam } from "../../../../utils/useOpenModalBySearchParam";
import { useRedirectToByKeyPress } from "../../../../utils/useRedirectToByKeyPress";
import { KEYBOARD_SHORTCUT_SEARCH } from "../../../../constants/keyboardShortcuts";
import { useCustomization } from "../../../customization";
import pluralize from "pluralize";
import { useGoToContractorImportStart } from "../../../BulkImporter/paths";

export const DashboardHeader: React.FC<WSElementProps> = props => {
  const { terminology } = useCustomization();
  const history = useHistory();
  const modalCreateContractor = useCreateContractorModal();

  useOpenModalBySearchParam("add_contractor", modalCreateContractor);

  const onAddContractor = useCallback(() => {
    modalCreateContractor.open({
      redirectToDetails: true
    });
  }, [modalCreateContractor]);

  useRedirectToByKeyPress(
    KEYBOARD_SHORTCUT_SEARCH,
    `${PAYEES_ROOT_PATH}/search`
  );
  const goToContractorImportStart = useGoToContractorImportStart();

  return (
    <WSPageToolbar
      title={pluralize.plural(terminology().sendPaymentsContractor)}
      actions={[
        {
          label: "Search",
          icon: "search",
          buttonKind: "Tertiary",
          hideButtonOn: false,
          buttonOrder: 0,
          onClick: () => history.push(`${PAYEES_ROOT_PATH}/search`)
        },
        {
          label: "Add contractor",
          icon: "plus",
          buttonKind: "Primary",
          onClick: onAddContractor
        },
        {
          label: "Bulk upload contractors",
          icon: "upload",
          onClick() {
            goToContractorImportStart();
          }
        },
        {
          separator: true
        },
        {
          label: "View archived contractors",
          icon: "archive",
          onClick() {
            history.push(`${PAYEES_ROOT_PATH}/archived`);
          }
        }
        // {
        //   label: "View archived engagements",
        //   icon: "archive",
        //   onClick() {
        //     alert("TODO");
        //     // history.push("/member/contractors/add-contractor");
        //   }
        // }
      ]}
    />
  );
};
